var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 0C15.6358 3.23131e-05 13.2952 0.465643 11.1113 1.37027C8.92749 2.27489 6.9432 3.6008 5.27178 5.27229C3.60036 6.94379 2.27453 8.92813 1.36999 11.112C0.46546 13.2959 -6.46214e-05 15.6366 6.72824e-09 18.0004C6.72824e-09 22.7742 1.89638 27.3524 5.27197 30.728C8.64756 34.1036 13.2258 36 17.9996 36C22.7735 36 27.3519 34.1036 30.7276 30.7281C34.1033 27.3525 35.9998 22.7742 36 18.0004C36 13.2264 34.1035 8.6479 30.7278 5.27217C27.3521 1.89645 22.7736 0 17.9996 0ZM19.7263 29.4594H16.3357V15.4583C17.2348 15.4582 18.0971 15.8153 18.7329 16.4509C19.3688 17.0866 19.7261 17.9487 19.7263 18.8478V29.4594ZM18.0124 12.0665C16.3146 12.0665 15.2663 10.862 15.2663 9.31255C15.2663 7.6964 16.3215 6.55958 18.0124 6.55958C19.6515 6.55958 20.7511 7.6964 20.7511 9.31255C20.7511 10.8628 19.6736 12.0665 18.0124 12.0665Z",
    fill: "#E30A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0124 6.56006C16.3215 6.56006 15.2664 7.69713 15.2664 9.31402C15.2664 10.8625 16.3136 12.067 18.0124 12.067C19.6736 12.067 20.7511 10.8625 20.7511 9.31402C20.7511 7.69713 19.6515 6.56006 18.0124 6.56006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3358 15.4575V29.4586H19.7263V18.8473C19.7262 17.9481 19.369 17.0858 18.7331 16.45C18.0973 15.8142 17.2349 15.457 16.3358 15.457",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.21a90df2b0fa5e83126831197f2aea7d.svg";
export { ForwardRef as ReactComponent };